import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { gaPageView } from '../../utils/gtag';

const GoogleAnalytics = () => {
    const { pathname, search } = useLocation();

    useEffect(() => {
        gaPageView(`${pathname}${search}`);
    }, [pathname, search]);

    return null;
};

export default GoogleAnalytics;
